import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root',
})
export class StatusResolverService extends ApiService {
  public getStatusData(): Observable<any> {
    return this.get<any>(ROUTES.GET_STATUS_RESOLVER, {});
  }
}
